import React, { Component } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { LogoHeader } from '../../../containers/Components/index'

class Media extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
    this.user_name = "";
    this.pwd = "";
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> Media </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-5 pt-2 line-height-h">
                      For most people, the first thing that comes to mind when they 
                      hear the words “virtual reality” is entertainment. After all, 
                      a VR headset seems on the surface to be essentially a very high-tech 
                      video game. The truth is, though, it goes far beyond that. Not everyone 
                      plays video games, but everyone loves to be entertained in one way or another. 
                      Movie theaters, TV, and even theme park rides are never going away, 
                      no matter how advanced VR becomes.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      On the contrary, it appears that virtual reality will support those entertainments 
                      more than replace them. Entertainment is often built on bringing the impossible to life. 
                      VR offers both a massive technology upgrade and a massive cost savings over simulating 
                      exotic environments in the real world.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      For example, theme park ride designers are catching onto this fact quickly. 
                      Parks across the world are already incorporating elements of virtual reality 
                      into their creations. Attractions like Disneyland’s Radiator Springs Racers, 
                      which cost over $200mm to construct, are not likely to go away, but they almost 
                      certainly will become a rare sight in the wake of financially accessible and 
                      wonderfully convincing virtual experiences.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      Check out our ever expanding Media templates:
                    </h6>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
                <Row className = "mt-5">
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col className = "mb-5 pb-5" xs="12" sm="12" lg="8">
                    <Row>
                      <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                      </Col>
                      <Col className ="text-right" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "../assets/img/logo.png" />
                        <h6 className = "text-center mt-3" > Template 1</h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2">Descriptions and details</Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col className ="text-left" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "../assets/img/logo.png" />
                        <h6 className = "text-center mt-3"> Template 2 </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2">Descriptions and details</Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
  
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default Media;



// WEBPACK FOOTER //
// ./src/views/Pages/Media/Media.js